import type { FieldMetadataMessageDescriptorDef } from './types';
import { msg } from '@lingui/core/macro';

export const vendorFields = {
  vendor_entity: {
    displayName: msg({
      message: 'Supplier',
      context: 'The display name for the supplier field',
    }),
  },
  vendor_subentity: {
    displayName: msg({
      message: 'Supplier subentity',
      context: 'The display name for the supplier subentity field',
    }),
  },
} as const satisfies Record<string, FieldMetadataMessageDescriptorDef>;
